export default __webpack_public_path__ + "static/logo-footer-a4c18c9a5cdd31d589b816fc49123129.svg";